export const formatBenchmarkValue = (value, unit) => {
  if (unit === 'percent') {
    return `${value}%`
  }

  if (unit === 'hours') {
    return `${value} hr`
  }

  if (unit === 'currency') {
    return `$${value.toLocaleString('en-US')}`
  }

  return String(value)
}

export const BENCHMARK_STATUS = {
  ABOVE_MEDIAN: 'aboveMedian',
  AT_MEDIAN: 'atMedian',
  BELOW_MEDIAN: 'belowMedian',
}

export const isAboveMedian = ({ coachValue, medianValue, higherIsBetter }) =>
  higherIsBetter ? coachValue >= medianValue : coachValue <= medianValue

export const isAtMedian = ({ coachValue, medianValue }) =>
  coachValue === medianValue

export const getBenchmarkStatusTier = metric => {
  if (isAtMedian(metric)) {
    return BENCHMARK_STATUS.AT_MEDIAN
  }

  if (isAboveMedian(metric)) {
    return BENCHMARK_STATUS.ABOVE_MEDIAN
  }

  return BENCHMARK_STATUS.BELOW_MEDIAN
}

export const getBenchmarkStatusLabel = tier => {
  switch (tier) {
    case BENCHMARK_STATUS.AT_MEDIAN:
      return 'At top coaches'
    case BENCHMARK_STATUS.ABOVE_MEDIAN:
      return 'Above top coaches'
    default:
      return 'Below top coaches'
  }
}

export const getDetailScaleRange = metric => {
  const {
    gettingStartedValue,
    top10Value,
    coachValue,
    medianValue,
    higherIsBetter,
  } = metric

  if (higherIsBetter) {
    const min = Math.min(0, gettingStartedValue, coachValue, medianValue)
    const max = Math.max(top10Value, coachValue, medianValue)

    return {
      min,
      max: max === min ? max + 1 : max,
    }
  }

  const min = Math.min(top10Value, coachValue, medianValue)
  const max = Math.max(gettingStartedValue, coachValue)

  return {
    min,
    max: max === min ? max + 1 : max,
  }
}

export const getDetailScalePercent = (value, metric) => {
  const { min, max } = getDetailScaleRange(metric)
  const span = max - min
  const normalized = metric.higherIsBetter
    ? (value - min) / span
    : (max - value) / span

  return Math.max(0, Math.min(100, normalized * 100))
}
